import React, { useEffect, useState } from 'react';
import { useCustomizer } from './context';
import Switch from '../../../components/padel/switch';
import Shape from '../../../components/utils/shape';
import Pinned from '../../../components/utils/pinned';
import { Mask } from '../../../components/utils/box';

import { colors } from '../../../styles';

const Mvp = () => {
  const [selected, setSelected] = useState(false);
  const { state, actions } = useCustomizer();
  
  const toggle = () => {
    const next = selected ? false : true;
    setSelected(next)
    actions.updateSlice('mvp', next);
  };
  return (
      <button type="button" className="io-unbutton -accent" 
          onClick={() => toggle()}>
            <Shape.Base
              vertices={state.level}
              size={60}
              fill={selected ? colors.accent : colors.accent_alpha}
            >
              <p className={selected ? ' txt-s' : ' txt-s'}>
                {' '}
                MVP
              </p>
            </Shape.Base>
      </button>
  );
};

export default Mvp;
